import axios from 'axios'
import config from '../utils/config'

//const EMPLOYEE_ENDPOINT = config.api[process.env.NODE_ENV].pre
const EMPLOYEE_ENDPOINT = config.api[process.env.NODE_ENV].hc360
const HC_360_ENDPOINT = config.api[process.env.NODE_ENV].hc360

/**
|--------------------------------------------------
| [GET] List Employee Events
|--------------------------------------------------
*/
// export const getListEmployeeEvents = (params = {}) =>
//   axios
//     .get(`${EMPLOYEE_ENDPOINT}/StaffEvent`, {
//       params: { ...params }
//     })
//     .then(response => response.data)
/**
|--------------------------------------------------
| [GET] List Employee In Staff Calendar
|--------------------------------------------------
*/
export const getListStaffCalendarLeave = (params = {}) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest/StaffCalendar`, {
      headers: { ...params }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Employee
|--------------------------------------------------
*/
export const getListEmployee = (params = {}) =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/Employees`, {
      headers: { ...params }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Detail Employee
|--------------------------------------------------
*/
export const getDetailEmployee = (employeeId, fieldSet) =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/Employees/${employeeId}`)
    .then(response => response.data)

export const getHouseMaster = employeeId =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/Employees/${employeeId}/MasterFamily`)
    .then(response => response.data)

export const updateHouseMaster = params =>
  axios
    .post(
      `${EMPLOYEE_ENDPOINT}/FamilyRelationship/${params.RelationshipId}`,
      params
    )
    .then(response => response.data)

export const createHouseMaster = params =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/FamilyRelationship`, params)
    .then(response => response.data)

/**
|--------------------------------------------------
| [PUT] Update Profile
|--------------------------------------------------
*/
export const updateEmployeeProfile = (employeeId, params) =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/Employees/${employeeId}`, params)
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Change Password
|--------------------------------------------------
*/
export const changePassword = params =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/Member/ChangePassword`, params)
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Change Password
|--------------------------------------------------
*/
export const forgotPassword = Email =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/Member/ForgotPassword`, { Email })
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Check Reset Password Token
|--------------------------------------------------
*/
export const recoveryTokenValidation = token =>
  axios
    .post(
      `${EMPLOYEE_ENDPOINT}/Member/CheckResetPasswordToken`,null, 
      {
        headers: {
          'Token': token
        }
      }
    )
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Reset Password
|--------------------------------------------------
*/
export const recoverPassword = params =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/Member/ResetPassword`, params)
    .then(response => response.data)

/**
 * [POST]
 * Upload Employee Avatar
 * @param {any} params
 * {
 *  ID - Employee ID
 *  file - Blob data
 * }
 */
export const uploadAvatar = params =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/FileUpload/EmployeeAvatar/`, params)
    .then(response => response.data)

/**
 * Get permissions of user
 *
 * @param {any} userId
 */
export const getUserRoles = userId =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/Roles`,{
      headers: {
        'EmployeeId': userId
      }
    })
    .then(response => response.data)

/**
 * Get List Family Relationship
 */
export const familyRelationshipList = userId =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/Employees/${userId}/FamilyRelationship`)
    .then(response => response.data)

/**
 * Get Detail Family Relationship
 */
export const familyRelationshipDetail = relationshipId =>
  axios
    .get(`${EMPLOYEE_ENDPOINT}/FamilyRelationship/${relationshipId}`)
    .then(response => response.data)

/**
 * Create Family Relationship
 *
 * @param {object} data
 * {
 *  EmployeeId,
 *  FullName,
 *  Sex,
 *  CellPhoneNo,
 *  RelationshipType,
 *  YearOfBirth,
 *  MonthOfBirth,
 *  DayOfBirth,
 *  Address,
 *  HomePhoneNo,
 *  Position,
 *  IdentityNumber,
 *  YearIdentityNumber,
 *  MonthIdentityNumber,
 *  DayIdentityNumber,
 *  PlaceIdentiryNumber,
 *  ImmigrationNo,
 *  TaxCode,
 *  StartDate,
 *  EndDate,
 *  IsEmrtgency,
 *  IsDependence
 * }
 */
export const createFamilyRelationship = data =>
  axios
    .post(`${EMPLOYEE_ENDPOINT}/FamilyRelationship`, data)
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/api/employee.js